import { InjectionToken } from '@angular/core';
import { UserAgentApplication } from 'msal';

export const MsalAuthInstance = new InjectionToken<UserAgentApplication>('MsalAuthInstance');
